module.exports = __webpack_public_path__ + "514477cfddfebc783e720f69f807966b.svg";